// API base URL. Defaults to production; override at build time with VITE_API_BASE_URL
// (e.g. the Cloudflare Pages preview build points it at codeblocks.sk).
export const API_BASE_URL =
  import.meta.env.VITE_API_BASE_URL ?? "https://be-partner-booking.turnago.sk/api"

export const BOOKING_REQUEST_WEBHOOK_URL =
  "https://n8n.codeblocks.sk/webhook/booking-request-form"
